import apiRoutes from './api.routes';
import ModelService from './model.service';

const FeedbackService = new ModelService(apiRoutes.feedback, '/users/feedback', 'feedback');

FeedbackService.getFile = (filename) => FeedbackService.getFilePathByDir('/uploads/cv', filename);

FeedbackService.STATUS_NEW = 1;
FeedbackService.STATUS_IN_PROGRESS = 2;
FeedbackService.STATUS_DONE = 3;

FeedbackService.TYPE_POSITION = 'position';
FeedbackService.TYPE_STARTUPS = 'for-startups';
FeedbackService.TYPE_GET_IN_TOUCH = 'get-in-touch';


FeedbackService.getStatusList = t => ({
  [FeedbackService.STATUS_NEW]: t('New'),
  [FeedbackService.STATUS_IN_PROGRESS]: t('In progress'),
  [FeedbackService.STATUS_DONE]: t('Done'),
});

FeedbackService.getTypeList = t => ({
  [FeedbackService.TYPE_POSITION]: t('Position'),
  [FeedbackService.TYPE_STARTUPS]: t('For startups'),
  [FeedbackService.TYPE_GET_IN_TOUCH]: t('Get-in-touch'),
});

FeedbackService.getStatusOptions = t => FeedbackService
  .prepareOptionsFromSimpleObject(FeedbackService.getStatusList(t));

FeedbackService.getTypeOptions = t => FeedbackService
  .prepareOptionsFromSimpleObject(FeedbackService.getTypeList(t));

FeedbackService.getStatusTitle = (status, t) => {
  const label = FeedbackService.getStatusList(t)[status];
  return label || '-';
};

FeedbackService.getColorByStatus = (status) => {
  switch (status) {
    case FeedbackService.STATUS_NEW:
      return 'success';
    case FeedbackService.STATUS_IN_PROGRESS:
      return 'warning';
    case FeedbackService.STATUS_DONE:
      return 'primary';
    default:
      return 'secondary';
  }
};

export default FeedbackService;



// WEBPACK FOOTER //
// ./src/services/feedback.service.js